import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  saveBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '18px',
    cursor: 'pointer'
  },
  badge: {
    margin: '16px 20px',
    padding: '12px 16px',
    background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)',
    border: '2px solid #8b5cf6',
    borderRadius: '12px',
    color: '#5b21b6',
    fontWeight: '600',
    textAlign: 'center',
    fontSize: '13px'
  },
  content: {
    padding: '0 20px'
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  appareilCard: {
    background: '#f8fafc',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '12px',
    border: '1px solid #e2e8f0'
  },
  appareilHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px'
  },
  appareilNumber: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#8b5cf6'
  },
  deleteBtn: {
    background: '#fee2e2',
    border: 'none',
    color: '#dc2626',
    padding: '6px 12px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  fieldGroup: {
    marginBottom: '12px'
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
    marginBottom: '6px'
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '10px',
    background: 'white',
    color: '#334155',
    boxSizing: 'border-box'
  },
  addButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#64748b'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#f8fafc'
  }
};

function Etape19MaterielsMesureMobile({ mission, onBack, onSave }) {
  const [data, setData] = useState({ appareils: [] });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadData();
  }, [mission.id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const savedData = await inspectionStorage.getStep(mission.id, 'etape_19_materiels_mesure');
      if (savedData && savedData.appareils) {
        setData(savedData);
      } else {
        // Initialiser avec des appareils par défaut si vide
        setData({
          appareils: [
            { fonction: 'Mesureur de terre', marque: '', type: '' },
            { fonction: 'Contrôleur d\'isolement', marque: '', type: '' },
            { fonction: 'Pince ampèremétrique', marque: '', type: '' }
          ]
        });
      }
    } catch (error) {
      console.error('❌ Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddAppareil = () => {
    setData(prev => ({
      ...prev,
      appareils: [...prev.appareils, { fonction: '', marque: '', type: '' }]
    }));
  };

  const handleUpdateAppareil = (index, field, value) => {
    setData(prev => {
      const newAppareils = [...prev.appareils];
      newAppareils[index] = { ...newAppareils[index], [field]: value };
      return { ...prev, appareils: newAppareils };
    });
  };

  const handleDeleteAppareil = (index) => {
    setData(prev => ({
      ...prev,
      appareils: prev.appareils.filter((_, i) => i !== index)
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_19_materiels_mesure', data);
      console.log('✅ Étape 19 sauvegardée');
      if (onSave) onSave(data);
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={styles.loading}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #e2e8f0',
          borderTopColor: '#8b5cf6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{marginTop: '16px', color: '#64748b', fontWeight: '500'}}>Chargement...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Matériels de mesure</h1>
        <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      {/* Badge RVRAT */}
      <div style={styles.badge}>
        🏛️ Rapport RVRAT - ERP 1er groupe<br/>
        <span style={{fontSize: '12px', fontWeight: '400'}}>Appareils de mesurage utilisés</span>
      </div>

      <div style={styles.content}>
        <div style={styles.card}>
          <div style={styles.sectionTitle}>
            🔧 Appareils de mesurage
          </div>

          {data.appareils.length === 0 ? (
            <div style={styles.emptyState}>
              <p style={{fontSize: '40px', marginBottom: '12px'}}>📦</p>
              <p style={{fontWeight: '600', marginBottom: '8px'}}>Aucun appareil ajouté</p>
              <p style={{fontSize: '14px'}}>Cliquez sur le bouton ci-dessous pour ajouter un appareil</p>
            </div>
          ) : (
            data.appareils.map((appareil, index) => (
              <div key={index} style={styles.appareilCard}>
                <div style={styles.appareilHeader}>
                  <span style={styles.appareilNumber}>Appareil #{index + 1}</span>
                  <button 
                    style={styles.deleteBtn}
                    onClick={() => handleDeleteAppareil(index)}
                  >
                    🗑️ Supprimer
                  </button>
                </div>

                <div style={styles.fieldGroup}>
                  <label style={styles.label}>Fonction</label>
                  <input
                    type="text"
                    style={styles.input}
                    value={appareil.fonction || ''}
                    onChange={(e) => handleUpdateAppareil(index, 'fonction', e.target.value)}
                    placeholder="Ex: Mesureur de terre"
                  />
                </div>

                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px'}}>
                  <div style={styles.fieldGroup}>
                    <label style={styles.label}>Marque</label>
                    <input
                      type="text"
                      style={styles.input}
                      value={appareil.marque || ''}
                      onChange={(e) => handleUpdateAppareil(index, 'marque', e.target.value)}
                      placeholder="Ex: FLUKE"
                    />
                  </div>
                  <div style={styles.fieldGroup}>
                    <label style={styles.label}>Type</label>
                    <input
                      type="text"
                      style={styles.input}
                      value={appareil.type || ''}
                      onChange={(e) => handleUpdateAppareil(index, 'type', e.target.value)}
                      placeholder="Ex: 1663"
                    />
                  </div>
                </div>
              </div>
            ))
          )}

          <button style={styles.addButton} onClick={handleAddAppareil}>
            ➕ Ajouter un appareil
          </button>
        </div>
      </div>

      {/* Bouton sauvegarder */}
      <div style={styles.saveSection}>
        <button 
          style={{...styles.saveButton, ...(saving ? {opacity: 0.6, cursor: 'not-allowed'} : {})}} 
          onClick={handleSave} 
          disabled={saving}
        >
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}

export default Etape19MaterielsMesureMobile;